import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import { type RootReducer } from "lib/redux/reducers";
import { getScriptsAdmin, verifyScript } from "lib/redux/scripts/action";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useClickOutside } from "utils/hooks";
import UploadScriptLayout from "./UploadScriptLayout";
import { statusOBJ } from "utils/constants";
import ConfirmationModal from "components/BaseModal";
import styled from "@emotion/styled";
import { nanoid } from "nanoid";
import { useQueryWrapper } from "services/apiHelper";
import { queryKeys } from "services/querykeys";
import { composersRequest } from "services/request";

interface composerListType {
  name: string;
  id: string;
}
const UploadScript = () => {
  const dispatch = useDispatch();

  const userScripts = useSelector((state: RootReducer) => state.scripts.adminScripts);
  useEffect(() => {
    dispatch(getScriptsAdmin(0));
  }, [dispatch]);

  const { data: allComposers } = useQueryWrapper(queryKeys.COMPOSERS, composersRequest.COMPOSER, {
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  const [currentScript, setCurrentScript] = useState<any>();
  const verifyClickedScript = (script, title, icon, isVerify) => {
    if (script.composerId === null) {
      setCurrentScript(script);
      onOpen();
      return;
    }
    Swal.fire({
      title,
      text: "You won't be able to revert this!",
      icon,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `${isVerify ? "Yes, verify it!" : "Yes, reject it"}`,
    })
      .then((result) => {
        if (result.isConfirmed) {
          if (isVerify) {
            dispatch(verifyScript({ id: script.id, status: statusOBJ.APPROVED }));
          } else {
            dispatch(verifyScript({ id: script.id, status: statusOBJ.REJECTED }));
          }
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [composerList, setComposerList] = useState<any>([]);
  const [currentSearch, setCurrentSearch] = useState<string>();
  const [showDropDown, setshowDropDown] = useState(false);
  const [selectedComposer, setselectedComposer] = useState<composerListType>({
    name: "",
    id: "",
  });
  const domNode = useClickOutside(() => {
    setshowDropDown(false);
  });
  const handleSelect = (composer: composerListType) => {
    setshowDropDown(false);
    setCurrentSearch(composer.name);
    setselectedComposer(composer);
  };

  const inputChanged = (e) => {
    const searchedText = e.target.value;

    setCurrentSearch(searchedText);
    if (!searchedText) {
      setshowDropDown(false);
      setComposerList([]);
      return;
    }
    const filteredComposer = allComposers.data.filter((composer) =>
      composer.name.toLowerCase().includes(searchedText.toLowerCase()),
    );
    if (filteredComposer.length > 0) {
      setComposerList(filteredComposer);
      setshowDropDown(true);
    } else {
      setshowDropDown(false);
    }
  };
  return (
    <div>
      <UploadScriptLayout
        scripts={userScripts.data}
        loading={userScripts.processing}
        verifyScript={verifyClickedScript}
      />
      <ConfirmationModal title="Script Info" isOpen={isOpen} onClose={onClose}>
        {currentScript && (
          <Box>
            <Text display="inline">Script Name:</Text>
            <Text fontWeight="bold" display="inline">
              {" "}
              {currentScript.name}
            </Text>
            <Box>
              <Text display="inline">Current Composer:</Text>
              <Text fontWeight="bold" display="inline">
                {"  "} {currentScript.composer}
              </Text>
            </Box>
            <Box mt="4">
              <FormControl id="composerName" isRequired mb={4}>
                <FormLabel>Composer</FormLabel>
                <ComposerListWrapper>
                  <Input
                    type="search"
                    onChange={inputChanged}
                    placeholder="Search Composer"
                    autoComplete="off"
                    value={currentSearch}
                  />
                  <div className={`customer-list ${showDropDown ? "active" : ""}`} ref={domNode}>
                    {composerList.length > 0
                      ? composerList.map((composer: any) => (
                          <button
                            type="button"
                            key={nanoid()}
                            onClick={() => {
                              handleSelect(composer);
                            }}
                          >
                            {composer.name}
                          </button>
                        ))
                      : null}
                  </div>
                </ComposerListWrapper>
                <FormHelperText m={0}>You can select unknown</FormHelperText>
              </FormControl>
            </Box>
            <Box mt="4">
              <Button
                onClick={() =>
                  dispatch(
                    verifyScript({
                      id: currentScript.id,
                      status: statusOBJ.APPROVED,
                      composerId: selectedComposer.id,
                    }),
                  )
                }
                disabled={selectedComposer.id === ""}
              >
                Submit
              </Button>
              <Button onClick={onClose} variant="secondary" ml="4">
                Cancel
              </Button>
            </Box>
          </Box>
        )}
      </ConfirmationModal>
    </div>
  );
};
const ComposerListWrapper = styled.div`
  position: relative;
  .customer-list {
    display: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 10rem;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    overflow-x: auto;
    h6 {
      padding: 12px 16px;
    }
    button {
      all: unset;
      display: block;
      padding: 12px 16px;
      width: 90%;
      text-transform: capitalize;
      :hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
    .nothing {
      /* background-color:red; */
      width: 100%;
      /* height:100%; */
      img {
        height: 100%;
        max-height: 110px;
      }
    }
  }
  .active {
    display: block;
  }
`;
export default UploadScript;
